module.exports = __webpack_public_path__ + "img/tutorial_war_10.aded5370.gif";